export enum Step {
  CREATE_AN_ACCOUNT = 1,
  BASIC_INFORMATION = 2,
  MY_DEVICES = 3,
  ABOUT_ME = 4,
  MY_INTERESTS = 5,
  ACCOUNT_MANAGER = 6
}
